import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 300 512" width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" {...props}><g data-name="Layer 2"><path d="M0 90h300v272H0zm0 362a60.07 60.07 0 0060 60h180a60.07 60.07 0 0060-60v-60H0zM240 0H60A60.07 60.07 0 000 60h300a60.07 60.07 0 00-60-60z" data-name="Capa 1" /></g></svg>);